var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"subtitle is-3 has-text-grey"},[_vm._v("Search Item for Mapping with Pathogen Data")]),_c('ListParts',{attrs:{"placeholderTxt":_vm.placeholderTxt},on:{"addItemToDetail":_vm.addItemToDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }